import React from 'react'

const Modal = () => {
  return (
   <div className="modal fade" id="eventsModal" tabindex="-1" aria-labelledby="eventsModalLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="eventsModalLabel">Additional Information</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
          <h3>Saturday Aug 1 - Kids Day activities include: </h3>
          <ul>
            <li>🎈 Bounce House – Front Common Area, 11:00 AM - 2:00 PM</li>
            <li>🎨 Balloon Artist – Pool,11:30 AM–1:30 PM</li>
            <li>🎣 Fishing Tournament – Marina (cast your line and compete!) - 10:00-11:00 AM</li>
            <li>🍪 Cookie Decorating – Pool, 10:00–11:00 AM</li>
            <li>🍔 Lunch – Pool Common Area, 12:00–2:00 PM</li>
            <li>🍧 Kona Ice Truck – Red Barn, 1:00–1:45 PM</li>
            <li>🐄 Meet the Milk Cows – Common Area (learn about farming and get up close with these gentle animals!) - All Day</li>
          </ul>
          <h3>Saturday Aug 1 - Cardboard Boat Races</h3>
          <p>Think you've got what it takes to build a boat that actually floats? 
            Put your creativity to the test using only cardboard and duct tape! Design, build, and race your homemade boat across the water before it sinks.</p>
          <h4>Choose your challenge: </h4>
          <ul>
            <li>👤 Solo Race – Build your own boat and paddle to victory.</li>
            <li>👥 Team Race – Grab a partner (or crew) and see if teamwork keeps you afloat!</li>
            <li>Boats may be constructed using only cardboard and duct tape.</li>
          </ul>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Modal